import { render, staticRenderFns } from "./ServiceproviderServicelist.vue?vue&type=template&id=6cd09e62&"
import script from "./ServiceproviderServicelist.vue?vue&type=script&lang=js&"
export * from "./ServiceproviderServicelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports